import {redirect} from 'next/navigation';
import {useParams} from 'react-router-dom';

/** categoryMenuId -> 라이브 탭으로 리다이렉트 */
export default function DiscoverCategory() {
  const {categoryMenuId} = useParams();
  redirect(`/directory/category/${categoryMenuId}/live`);
}
